import { EnvBanner, initAxiosInstance } from '@unipile/ui';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { AppProvider } from './AppProvider';
import { registerTrads } from './libs/i18n';
import Router from './routes/Router';
import './styles.css';

/**
 * This function runs before the React App is bootstrapped and before anything appear on the screen
 * Dont put long lasting code here
 */
async function preRender() {
  console.log({
    version: import.meta.env.VITE_APP_VERSION,
    api_base_url: import.meta.env.VITE_API_BASE_URL,
    mode: import.meta.env.MODE,
  });

  initAxiosInstance(import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000', (instance) => {
    instance.interceptors.response.use((response) => {
      return response;
    });
  });
  await registerTrads();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

preRender()
  .then(() =>
    root.render(
      <StrictMode>
        <AppProvider>
          <EnvBanner>
            <Router />
          </EnvBanner>
        </AppProvider>
      </StrictMode>,
    ),
  )
  .catch((err) => {
    console.error('Error occured during preRender', err);
  });
